'use client';
import type { ChangeEvent, FunctionComponent } from 'react';
import { useRouter } from 'next/navigation';

import { testsCategoryUrl } from '../../services/route-utils';

type Props = {
    categories: any[];
    selected: any;
};

const TestCategories: FunctionComponent<Props> = ({ categories, selected }) => {
    const router = useRouter();

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const item = e.target.value;
        router.push(testsCategoryUrl(item ? { slug: item } : null));
    };

    return (
        <select onChange={handleChange} value={selected || ''}>
            <option value="">Toate categoriile</option>
            {categories.map((c) => (
                <option key={c.slug} value={c.slug}>
                    {c.name}
                </option>
            ))}
        </select>
    );
};

TestCategories.displayName = 'TestCategories';

export default TestCategories;
